;(function ($, w, u) {
    var ComparisonTable = function (skin, selector, events) {
        this.skin = skin;
        this.container = $(selector);
        this.attachEventHandlers(events);
        this.showAllParamsStatus = true;
        this.init();
    };


    ComparisonTable.instance = null;
    ComparisonTable.ajaxUri = GLOBAL.URI_PREFIX + '_widget/comparison_table/';
    ComparisonTable.createInstance = function (skin, selector, events) {
        this.instance = new this(skin, selector, events);
    };
    ComparisonTable.getInstance = function (skin, selector, events) {
        if (selector) {
            this.createInstance(skin, selector, events);
        }

        return this.instance;
    };

    ComparisonTable.prototype = {
        init: function () {
            this.loader = this.container.find('.j-loader');
            this.content = this.container.find('.j-content');
            this.tabs_container = this.container.find('.j-tabs');
            this.close = this.container.find('.j-close');
            this.clear = this.container.find('.j-clear');

            this.initTabs();
            this.initDifference();
            this.initProducts();
            this.initDOMEvents();
            this.trigger('onInit');
        },

        initDOMEvents: function () {
            var self = this;
            this.close.off('click').on('click', function (e) {
                Modal.close();

                e.preventDefault();
            });
            this.clear.off('click').on('click', function () {
                var handlerId = $(this).data('handler-id');

                if (self.trigger('onBeforeClear', handlerId) !== false) {
                    self.clearProducts(handlerId);
                }
                return false;
            });
        },

        clearProducts : function (handlerId) {
            var self = this;

            ComparisonList.clear(handlerId, function () {
                self.loadContent(handlerId);
            });
        },

        initProducts : function () {
            this.products = this.container.find('.j-comparison-product');
            this.productsIds = [];
            var self = this;
            this.products.each(function () {
                var me = $(this),
                    id = me.data('id'),
                    handlerId = me.data('handler-id');

                me.find('.j-remove')
                    .off('.ComparisonTable')
                    .on('click.ComparisonTable', function () {
                        if (self.trigger('onBeforeRemoveProduct') !== false) {
                            ComparisonList.removeProduct(handlerId, id, function () {
                                self.loadContent(handlerId);
                            });
                        }
                        return false;
                    });

                if ($.inArray(id, self.productsIds) === -1) {
                    self.productsIds.push(id);
                }
            });
        },

        initTabs : function () {
            var self = this;
            this.tabs = this.container.find('.j-compare-tab');
            this.contentIds = [];


            this.tabs
                .off('.ComparisonTable')
                .on('click.ComparisonTable', function () {
                    var content_id = $(this).data('id');

                    self.loadContent(content_id);

                    return false;
                })
                .each(function () {
                    var id = $(this).data('id');
                    if ($.inArray(id, self.contentIds) === -1) {
                        self.contentIds.push(id);
                    }
                });
        },

        initDifference : function () {
            this.paramsAllButton         = this.container.find('.j-params-all');
            this.paramsDifferencesButton = this.container.find('.j-params-differences');
            this.noDifferencesContainers = this.container.find('.j-no-difference');
            var self = this;
            this.paramsAllButton.off('.ComparisonTable').on('click.ComparisonTable', function (e) {
                self.showAllParams();
                e.preventDefault();
            });
            this.paramsDifferencesButton.off('.ComparisonTable').on('click.ComparisonTable', function (e) {
                self.showParamsDifferences();
                e.preventDefault();
            });
        },

        showAllParams: function () {
            this.paramsAllButton.addClass('__active is-active');
            this.paramsDifferencesButton.removeClass('__active is-active');
            this.noDifferencesContainers.show();
            this.showAllParamsStatus = true;
            this.trigger('onAfterDifferencesChange', this.paramsAllButton);
        },

        showParamsDifferences: function () {
            this.paramsAllButton.removeClass('__active is-active');
            this.paramsDifferencesButton.addClass('__active is-active');
            this.noDifferencesContainers.hide();
            this.showAllParamsStatus = false;
            this.trigger('onAfterDifferencesChange', this.paramsDifferencesButton);
        },

        toggleParamsDifference: function () {
            if (this.showAllParamsStatus) {
                this.showParamsDifferences();
            } else {
                this.showAllParams();
            }
        },

        loadContent : function (content_id) {
            //if ($.inArray(content_id, this.contentIds) == -1) {
            //    this.trigger('onContentLoadError', 1, 'incorrect content_id');
            //    return;
            //}
            this.tabs.removeClass('__active').filter('[data-id="' + content_id + '"]').addClass('__active');

            this.trigger('onBeforeLoadContent', content_id);
            var self = this;
            this.ajax(
                'loadContent/' + this.skin + (content_id ? '/' + content_id : ''),
                null,
                function (status, response) {
                    if (status === 'OK') {
                        self.content.empty().append(response.content);
                        self.tabs_container.empty().append(response.tabs);
                        self.trigger('onBeforeContentInit');
                        self.init();
                        self.trigger('onAfterContentInit');
                    }
                }
            );
        },

        ajax: function (action, params, callback) {
            var self = this;
            this.loader.show();
            this.trigger('onBeforeAjax', action, params);
            return sendAjax(ComparisonTable.ajaxUri + action + '/', params, function (status, response) {
                self.loader.hide();
                self.trigger('onAfterAjax', action, status, response);

                if (typeof callback === 'function') {
                    callback(status, response);
                }
            });
        },

        openModal: function (content_id) {
            var self = this;

            this.loadContent(content_id);
            Modal.open(this.container, {
                beforeOpen: function () {
                    return self.trigger('onBeforeOpenModal');
                },
                afterOpen: function () {
                    return self.trigger('onAfterOpenModal');
                },
                beforeClose: function () {
                    return self.trigger('onBeforeCloseModal');
                },
                afterClose: function () {
                    return self.trigger('onAfterCloseModal');
                }
            }, true);
        }
    };

    $.extend(ComparisonTable.prototype, TMEvents);

    w.ComparisonTable = ComparisonTable;
})(jQuery, window);